import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SET_MAIN_LOADER } from '../redux/loaderSlice';
import { SET_LOGIN_FORM_ERROR, SHOW_MAIN_ERROR_MODAL } from '../redux/errorMessageSlice';
import { SET_ADVANCE_DRAW_SELECT_TIME, SET_ANNOUCEMENTS, SET_AUTO_RESULT_DATA, SET_CLAIM_TICKET_RECORD, SET_CURRENT_GAME_TIME, SET_GAME_TIMER, SET_LAST_SALE_AMOUNT, SET_LAST_TICKET_ID, SET_LAST_WIN_CARD, SET_LOTTERY_REPORT, SET_NEXT_GAME_TIME, SET_PREVIEWS_GAME_TIME, SET_REPRNT_LIST, SET_RESULT_DATA, SET_TIME_SLOT, SET_TR_CODE, SET_USER_WALLET, SET_WIN_LOSE_RECORD, clearWinLoseRecord } from '../redux/2d-slice/gameInfo2dSlice';
import { SHOW_MAIN_SUCCESS_MODAL } from '../redux/successMessageSlice';
import { PrintData } from '../comonComponent/print-2d/PrintLottery';
import { RePrintData } from '../comonComponent/print-2d/RePrintLottery';
import { RePrintData1d } from '../comonComponent/print-1d/RePrintLottery';

import { PrintDataTitli } from '../comonComponent/print-titli/PrintTitli';
import { RePrintDataTitli } from '../comonComponent/print-titli/RePrintTitli';

import { RESET_SLICE_STATE } from '../redux/2d-slice/seriesSlice2d';
import { SocketState } from './SocketProvider';
import { ResultTimeSet3d, SET_CLAIM_TICKET_RECORD_3D, setLastSaleAmount3d, setLotteryBetList3d, setLotteryPlaceBet3d, setLotteryReport3d, setPcikNextDelalTime, setPICK_Announcement, setPickGameData, setPickGameTimer, setPickkCurrentDrawTime, setPickLastTrNo, setPickLastWinCards, setPrintTicketData3d, SET_WIN_LOSE_RECORD_3D, setResultDates3d, setTimeSlotData3d, clearWinLoseRecord3d, setWalletAmount3d } from '../redux/3d_game_Slice/gameinfo3d';
import { setAdvanceTimeSlotCount, setLoaderShow, setSelectTimeSlot } from '../redux/seriesSlice';
import { SET_TITLI_ADVANCE_DRAW_SELECT_TIME, SET_TITLI_ANNOUCEMENTS, SET_TITLI_AUTO_RESULT_DATA, SET_TITLI_CLAIM_TICKET_RECORD, SET_TITLI_CURRENT_GAME_TIME, SET_TITLI_GAME_TIMER, SET_RESULT_TIME_TITLI, SET_TITLI_PRINT_DATA, SET_RESULT_DATES_TITLI, SET_TITLI_LAST_SALE_AMOUNT, SET_TITLI_LAST_TICKET_ID, clearTitliWinLoseRecord, SET_TITLI_LAST_WIN_CARD, SET_TITLI_LOTTERY_REPORT, SET_TITLI_NEXT_GAME_TIME, SET_TITLI_PREVIEWS_GAME_TIME, SET_TITLI_REPRNT_LIST, SET_TITLI_RESULT_DATA, SET_TITLI_TIME_SLOT, SET_TITLI_TR_CODE, SET_TITLI_USER_WALLET, SET_TITLI_WIN_LOSE_RECORD } from '../redux/titli-slice/gameInfoTitliSlice';

import {
  SelectSeriesPartAll,
  RESET_1D_SLICE_STATE,
  SelectSeriesPart,
  SET_SERIES_PART_CHECKED,
  SET_SERIES_TYPE,
  SelectSeriesType,
  SET_ACTIVE_SERIES_INDEX,
  SelectActiveSeriesPartIndex, SET_LAST_INPUT_CHANGE_RECORD,
  SelectActiveSeriesIndex,
  SET_ACTIVE_SERIES_PART_INDEX,
  SelecrSeriesStore,
  SET_PREVIEWS_ACTIVE_SERIES_DETAIL,
  SelectSeriesTypeDisableFlag,
  SET_IS_MULTI,
  SelectIsMulti,
  SET_SERIES_STORE,
  SET_RESULT_ARRAY,
  SelectResultArray
} from "../redux/1d-slice/seriesSlice1d";

import {
  SET_1D_GAME_TIMER,
  SET_1D_CURRENT_GAME_TIME,
  SET_1D_NEXT_GAME_TIME,
  SET_1D_COUPEN_VALUE,
  SET_1D_USER_WALLET,
  SET_1D_LAST_WIN_CARD,
  SET_1D_TIME_SLOT,
  SET_1D_ADVANCE_DRAW_SELECT_TIME,
  SET_1D_LAST_SALE_AMOUNT,
  SET_1D_LAST_TICKET_ID,
  SET_1D_LOTTERY_REPORT,
  SET_1D_CLAIM_TICKET_ID,
  SET_1D_CLAIM_TICKET_RECORD,
  SET_1D_PRINT_DATA,
  SET_1D_REPRNT_LIST,
  SET_1D_RESULT_DATA,
  SET_1D_AUTO_RESULT_DATA,
  SET_1D_ANNOUCEMENTS,
  SET_1D_PREVIEWS_GAME_TIME,
  SET_1D_TR_CODE,
  SET_1D_WIN_LOSE_RECORD,
  SET_RESULT_DATES_1D,
  SET_RESULT_TIME_1D,
  clear1DWinLoseRecord
} from '../redux/1d-slice/gameInfo1dSlice';
import { resetPanel } from '../redux/3d_game_Slice/panelSlice';
import { SET_PANA_GAME_INFO, SET_PANA_WALLET, SET_PANA_WIN_LOSE_RECORD } from '../redux/pana-slice/gameInfoPanaSlice';
import { toast } from 'react-toastify';

const AuthContext = createContext();

function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socket, connectionError, reconnect } = SocketState();
  const [userDetail, setUserDetail] = useState(null);
  const [navigateFlag, setNavigateFlag] = useState(true);


  useEffect(() => {
    const handleSocketResponse = (response) => {
      switch (response.en) {
        case 'VIEW_GAME_INFO':
          if (!response.err) {
            if (response.data.game_type === 'pick_three_game') {
              navigate('/3d');
              dispatch(setPickGameData({ ...response }));
              dispatch(setPickGameTimer(response.data.timer));
              dispatch(setPcikNextDelalTime(response.data.next_deal_time))
              dispatch(setPickLastTrNo(response.data.ticket_id));
              dispatch(setPickkCurrentDrawTime(response.data.current_draw_time))
              dispatch(setPickLastWinCards(response.data.last_win_cards));
              dispatch(setWalletAmount3d(response.data.total_wallet));
              dispatch(setLastSaleAmount3d(response.data.last_sale_amount));
              dispatch(setPICK_Announcement(response.data.annoucements))
            } else if (response.data.game_type === "mini_lottery_game") {
              dispatch(SET_MAIN_LOADER(false));
              dispatch(SET_GAME_TIMER(response.data.timer));
              dispatch(SET_LAST_WIN_CARD(response.data.last_win_cards));
              dispatch(SET_CURRENT_GAME_TIME(response.data.draw_time));
              dispatch(SET_NEXT_GAME_TIME(response.data.next_deal_time));
              dispatch(SET_LAST_SALE_AMOUNT(response.data.last_sale_amount));
              dispatch(SET_TR_CODE(response.data.game_id));
              dispatch(SET_LAST_TICKET_ID(response.data.ticket_id));
              dispatch(SET_USER_WALLET(response.data.total_wallet));
              dispatch(SET_ANNOUCEMENTS(response.data.annoucements));
              navigate('/2d');
            } else if (response.data.game_type === "lucky_sorat") {
              dispatch(SET_MAIN_LOADER(false));
              dispatch(SET_TITLI_GAME_TIMER(response.data.timer));
              dispatch(SET_TITLI_LAST_WIN_CARD(response.data.last_win_cards));
              dispatch(SET_TITLI_CURRENT_GAME_TIME(response.data.draw_time));
              dispatch(SET_TITLI_NEXT_GAME_TIME(response.data.next_deal_time));
              dispatch(SET_TITLI_LAST_SALE_AMOUNT(response.data.last_sale_amount));
              dispatch(SET_TITLI_TR_CODE(response.data.game_id));
              dispatch(SET_TITLI_LAST_TICKET_ID(response.data.ticket_id));
              dispatch(SET_TITLI_USER_WALLET(response.data.total_wallet));
              dispatch(SET_TITLI_ANNOUCEMENTS(response.data.annoucements));
              navigate('/titli');
            } else if (response.data.game_type === "two_chance") {
              dispatch(SET_MAIN_LOADER(false));
              dispatch(SET_1D_GAME_TIMER(response.data.timer));
              dispatch(SET_1D_LAST_WIN_CARD(response.data.last_win_cards));
              dispatch(SET_1D_CURRENT_GAME_TIME(response.data.draw_time));
              dispatch(SET_1D_NEXT_GAME_TIME(response.data.next_deal_time));
              dispatch(SET_1D_LAST_SALE_AMOUNT(response.data.last_sale_amount));
              dispatch(SET_1D_TR_CODE(response.data.game_id));
              dispatch(SET_1D_LAST_TICKET_ID(response.data.ticket_id));
              dispatch(SET_1D_USER_WALLET(response.data.total_wallet));
              dispatch(SET_1D_ANNOUCEMENTS(response.data.annoucements));
              navigate('/1d');
            } else if (response.data.game_type === "play_matka") {
              dispatch(SET_MAIN_LOADER(false));
              dispatch(SET_PANA_GAME_INFO(response.data));
              // only route to pana on entry (login); refreshes while on pana must not navigate
              if (!window.location.pathname.includes('/pana-game')) navigate('/pana-game');
            }
            // Set win card data if available
            const winCardData = response.data.last_win_cards || [];
            dispatch(SET_LAST_WIN_CARD(winCardData));
          }
          break;

        case 'MINI_LOTTERY_ADVANCE_DRAW_TIME_SLOT':
          if (!response.err) {
            dispatch(SET_TIME_SLOT(response.data.time_slot));
          }
          break;
        case 'LUCKY_SORAT_ADVANCE_DRAW_TIME_SLOT':
          if (!response.err) {
            dispatch(SET_MAIN_LOADER(false))
            dispatch(SET_TITLI_TIME_SLOT(response.data.time_slot));
            }
          break;
        case 'PICK_THREE_ADVANCE_DRAW_TIME_SLOT':
          if (!response.err) {
            dispatch(SET_MAIN_LOADER(false))
            dispatch(setTimeSlotData3d(response.data.time_slot));
          }
          break;
        case 'TWO_CHANCE_ADVANCE_DRAW_TIME_SLOT':
          if (!response.err) {
            dispatch(SET_MAIN_LOADER(false))
            dispatch(SET_1D_TIME_SLOT(response.data.time_slot));
          }
          break;

        // Add more cases for other response types as needed
        default:
          // Handle unknown response types or do nothing
          break;
      }
    };

    // Listen for all responses
    socket.on('res', handleSocketResponse);

    // Clean up the socket listener
    return () => {
      socket.off('res', handleSocketResponse);
    };
  }, [dispatch, navigate]);

  
  const handleSocketResponse = useCallback((socketData) => {
    console.log("socketData--", socketData);

    if (socketData.err && socketData.msg === 'User session not set, please restart game!') {
      toast.error(socketData.msg);
      socket?.disconnect();
      return;
    }

    // While on the pana game, ignore other games' broadcast events (LOCK_BET / WINNER_DECLARE /
    // START_SPIN etc.) so the user is not pulled into 2d/3d/titli/1d. Pana handles its own
    // PLAY_MATKA_* events locally; this only triggers on the pana route, so other games are unaffected.
    const onPana = window.location.pathname.includes('/pana-game') || localStorage.getItem('gameRoute') === 'pana';
    if (onPana && /^(MINI_LOTTERY_|PICK_THREE_|LUCKY_SORAT_|TWO_CHANCE_)/.test(socketData.en || '')) {
      return;
    }
    // ---- pana (play_matka) core events (handled early; their error responses may lack `data`) ----
    if (socketData.en === "PLAY_MATKA_PLACE_BET") {
      if (socketData.err) {
        toast.error(socketData.msg || 'Bet failed');
      } else {
        // wallet updates via UPDATED_WALLET; no VIEW_GAME_INFO refresh needed (like 3d)
        toast.success(socketData.msg || 'Bet placed successfully');
      }
      return;
    }
    if (socketData.en === "PLAY_MATKA_TICKET_CLAIM") {
      // open the win/lose popup with the claim result (like 3d)
      dispatch(clearWinLoseRecord());
      dispatch(clear1DWinLoseRecord());
      dispatch(clearWinLoseRecord3d());
      dispatch(clearTitliWinLoseRecord());
      dispatch(SET_PANA_WIN_LOSE_RECORD(socketData));
      navigate('/pana-game/win-lose-result');
      return;
    }

    // AppLaunch Detail
    if (socketData.en === "AppLunchDetails") {
      dispatch(SET_MAIN_LOADER(false));
      if (socketData.err) {
        dispatch(SET_LOGIN_FORM_ERROR(socketData.msg));
        return;
      }
      localStorage.setItem('gst', socketData.data.gst_no);
      localStorage.setItem('is_gst', socketData.data.is_gst);
      // Persist the login credentials under the key the reconnect/re-auth path
      // reads ('creditionls'), so a transient socket drop (e.g. tab switch)
      // silently re-authenticates instead of logging the user out.
      const savedCreds = localStorage.getItem('creditionlsDetails');
      if (savedCreds) {
        localStorage.setItem('creditionls', savedCreds);
      }
      setUserDetail(socketData.data);
      dispatch(SET_1D_USER_WALLET(socketData.data.chips+socketData.data.game_winning))
      console.log('socketData.data', socketData.data)
      // pana fetches its own VIEW_GAME_INFO on mount; just route there (avoids a double call)
      if (localStorage.getItem('gameRoute') === 'pana') {
        navigate('/pana-game');
      } else {
        socket?.emit('req', {
          "en": "VIEW_GAME_INFO",
          "data": {
            "game_type": (() => {
              const route = localStorage.getItem('gameRoute');
              if (route === '2d') return '2d';
              if (route === '3d') return 'pick_three';
              if (route === 'Titli') return 'lucky_sorat'; // 👈 added Titli condition
              if (route === '1d') return 'two_chance'; // 👈 added 1d condition
              return '2d';
            })()
          }
        });
      }
    }

    if (socketData.en === 'LUCKY_SORAT_REMAING_TIMER') {
      console.log('LUCKY_SORAT_REMAING_TIMER')
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_TITLI_GAME_TIMER(socketData.data.timer))
    }
    if (socketData.en === "LUCKY_SORAT_WINNER_DECLARE") {
      console.log('LUCKY_SORAT_WINNER_DECLARE')
      if (socketData.err) {
        dispatch(setLoaderShow(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_TITLI_LAST_WIN_CARD(socketData.data.last_win_cards));
      dispatch(SET_TITLI_NEXT_GAME_TIME(socketData.data.next_deal_time));
    }

    if (socketData.en === "TWO_CHANCE_WINNER_DECLARE") {
      console.log('TWO_CHANCE_WINNER_DECLARE')
      if (socketData.err) {
        dispatch(setLoaderShow(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_1D_LAST_WIN_CARD(socketData.data.last_win_cards));
      dispatch(SET_1D_NEXT_GAME_TIME(socketData.data.next_deal_time));
    }

    if (socketData.en === "LUCKY_SORAT_RESULTS_HISTORY") {
      console.log(socketData.data.dates)
      if (socketData.err) {
        dispatch(setLoaderShow(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_RESULT_DATES_TITLI(socketData.data.dates));
      dispatch(SET_RESULT_TIME_TITLI(socketData.data.time_result));
      console.log('LUCKY_SORAT_RESULTS_HISTORY')
    }

    if (socketData.en === "TWO_CHANCE_RESULT_HISTORY") {
      console.log(socketData.data.dates)
      if (socketData.err) {
        dispatch(setLoaderShow(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_RESULT_DATES_1D(socketData.data.dates));
      dispatch(SET_RESULT_TIME_1D(socketData.data.time_result));
      console.log('TWO_CHANCE_RESULTS_HISTORY')
    }

    if (socketData.en === "LUCKY_SORAT_START_SPIN") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      navigate('/titli');
      dispatch(SET_MAIN_LOADER(true))
      dispatch(SET_TITLI_GAME_TIMER(socketData.data.timer))
    }

    if (socketData.en === "TWO_CHANCE_START_SPIN") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      navigate('/1d');
      dispatch(SET_MAIN_LOADER(true))
      dispatch(SET_1D_GAME_TIMER(socketData.data.timer))
    }

    if (socketData.en === "LUCKY_SORAT_INIT_GAME") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_TITLI_GAME_TIMER(socketData.data.timer))
    }

    if (socketData.en === "TWO_CHANCE_INIT_GAME") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_1D_GAME_TIMER(socketData.data.timer))
    }

    if (socketData.en === "LUCKY_SORAT_GAME_TIMER_START") {
      // window.location.reload();
      dispatch(SET_TITLI_GAME_TIMER(socketData.data.timer))
      dispatch(SET_TITLI_CURRENT_GAME_TIME(socketData.data.draw_time))
      dispatch(SET_TITLI_NEXT_GAME_TIME(socketData.data.next_deal_time))
      dispatch(SET_MAIN_LOADER(false))
    }

    if (socketData.en === "TWO_CHANCE_GAME_TIMER_START") {
      // window.location.reload();
      dispatch(SET_1D_GAME_TIMER(socketData.data.timer))
      dispatch(SET_1D_CURRENT_GAME_TIME(socketData.data.draw_time))
      dispatch(SET_1D_NEXT_GAME_TIME(socketData.data.next_deal_time))
      dispatch(SET_MAIN_LOADER(false))
    }

    // if (socketData.en === "LUCKY_SORAT_PLACE_BET") {
    //   if (socketData.err) {
    //     dispatch(SET_MAIN_LOADER(false))
    //     dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
    //     return
    //   }
    //   dispatch(SET_TITLI_LAST_SALE_AMOUNT(socketData.data.total_bet_amount))
    //   dispatch(SET_TITLI_LAST_TICKET_ID(socketData.data.ticket_id))
    //   dispatch(SET_TITLI_PRINT_DATA(socketData.data))
    //   // PrintDataTitli(socketData.data, dispatch)
    //   dispatch(RESET_SLICE_STATE());
    //   dispatch(SET_TITLI_ADVANCE_DRAW_SELECT_TIME([]))
    //   dispatch(setAdvanceTimeSlotCount(0))
    // }

    if (socketData.en === "LUCKY_SORAT_GAME_INFO") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false));
      dispatch(SET_TITLI_GAME_TIMER(socketData.data.timer));
      dispatch(SET_TITLI_LAST_WIN_CARD(socketData.data.last_win_cards));
      dispatch(SET_TITLI_CURRENT_GAME_TIME(socketData.data.draw_time));
      dispatch(SET_TITLI_NEXT_GAME_TIME(socketData.data.next_deal_time));
      dispatch(SET_TITLI_LAST_SALE_AMOUNT(socketData.data.last_sale_amount));
      dispatch(SET_TITLI_TR_CODE(socketData.data.game_id));
      dispatch(SET_TITLI_LAST_TICKET_ID(socketData.data.ticket_id));
      dispatch(SET_TITLI_USER_WALLET(socketData.data.total_wallet));
      dispatch(SET_TITLI_ANNOUCEMENTS(socketData.data.annoucements));
    }

    if (socketData.en === "TWO_CHANCE_GAME_INFO") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false));
      dispatch(SET_1D_GAME_TIMER(socketData.data.timer));
      dispatch(SET_1D_LAST_WIN_CARD(socketData.data.last_win_cards));
      dispatch(SET_1D_CURRENT_GAME_TIME(socketData.data.draw_time));
      dispatch(SET_1D_NEXT_GAME_TIME(socketData.data.next_deal_time));
      dispatch(SET_1D_LAST_SALE_AMOUNT(socketData.data.last_sale_amount));
      dispatch(SET_1D_TR_CODE(socketData.data.game_id));
      dispatch(SET_1D_LAST_TICKET_ID(socketData.data.ticket_id));
      dispatch(SET_1D_USER_WALLET(socketData.data.total_wallet));
      dispatch(SET_1D_ANNOUCEMENTS(socketData.data.annoucements));
    }

    if (socketData.en === "LOTTARY_CLOSE_GAME") {
      let gameType = localStorage.getItem('gameRoute');
      console.log(gameType)
      let game_type = "2d"; // default

      if (gameType === "3d") {
        game_type = "pick_three";
      } else if (gameType === "Titli") {
        game_type = "lucky_sorat";
      } else if (gameType === "1d") {
        game_type = "two_chance";
      } else if (gameType === "pana") {
        game_type = "play_matka";
      }

      let data = {
        "en": "VIEW_GAME_INFO",
        "data": {
          "game_type": game_type
        }
      };
      console.log(data)
      socket.emit('req', data);
      return;
    }

    if (socketData.en === 'PICK_THREE_TICKET_CLAIM') {
      dispatch(SET_MAIN_LOADER(false))
      dispatch(clearWinLoseRecord());
      dispatch(clearTitliWinLoseRecord());
      dispatch(SET_WIN_LOSE_RECORD_3D(socketData))
      navigate('/3d/win-lose-result')
      dispatch(SET_CLAIM_TICKET_RECORD_3D(socketData))
    }


    if (socketData.en === "PICK_THREE_PLACE_BET") {
      dispatch(setLoaderShow(false));
      dispatch(setPickLastTrNo(socketData.data.ticket_id));
      dispatch(setLotteryPlaceBet3d({ ...socketData.data }));
      dispatch(setLastSaleAmount3d(socketData.data.total_bet_amount));
      dispatch(resetPanel())
      dispatch(setSelectTimeSlot([]))
      dispatch(setAdvanceTimeSlotCount(0))
      if (socketData.err) {
        toast.error(socketData?.msg);
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
      }
      if (socketData.data.bet_details) {
        navigate(`/3d`);
        toast.success("Bat succesfully.");
      }
      return
    }


    if (socketData.data.game_type === 'pick_three_game') {
      if (socketData.en === "PICK_THREE_CLOSE_GAME") {
        if (socketData.err) {
          dispatch(SET_MAIN_LOADER(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        localStorage.setItem('gameRoute', '2d');
        setNavigateFlag(false);
        let data = {
          "en": "VIEW_GAME_INFO",
          "data": {
            "game_type": '2d'
          }
        }
        socket.emit('req', data)
        return
      }


      if (socketData.en === 'PICK_THREE_REMAING_TIMER') {
        if (socketData.err) {
          dispatch(SET_MAIN_LOADER(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(SET_GAME_TIMER(socketData.data.timer))
      }

      if (socketData.en === 'TWO_CHANCE_REMAING_TIMER') {
        if (socketData.err) {
          dispatch(SET_MAIN_LOADER(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(SET_1D_GAME_TIMER(socketData.data.timer))
      }
      if (socketData.en === "PICK_THREE_CANCEL_TICKET") {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        navigate(`/3d`);
        if (!socketData.err) toast.success(socketData.msg);
        else toast.error(socketData.msg);
      }
    } else {
      if (socketData.en === "PICK_THREE_LOCK_BET") {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(setLoaderShow(true))
      } else if (socketData.en === 'PICK_THREE_TIMER_START') {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(setLoaderShow(false))
        dispatch(setPickGameTimer(socketData.data.timer));
        dispatch(setPickkCurrentDrawTime(socketData.data.current_draw_time))
      } else if (socketData.en === "PICK_THREE_GET_BET_LISTS") {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        console.log('PICK_THREE_GET_BET_LISTS', socketData.data.list)
        dispatch(setLoaderShow(false));
        dispatch(setLotteryBetList3d(socketData.data.list));
      } else if (socketData.en === 'PICK_THREE_PRINT_TICKETS') {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(setLoaderShow(false));
        dispatch(setPrintTicketData3d(socketData.data.ticket_info));
      } else if (socketData.en === "PICK_THREE_WINNER_DECLARE") {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(setPickLastWinCards(socketData.data.last_win_cards));
      } else if (socketData.en === "PICK_THREE_RESULTS_HISTORY") {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        dispatch(setResultDates3d(socketData.data.dates));
        dispatch(ResultTimeSet3d(socketData.data.time_result));

      }
      if (socketData.en === "PICK_THREE_CANCEL_TICKET") {
        if (socketData.err) {
          dispatch(setLoaderShow(false))
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
          return
        }
        navigate(`/3d`);
        if (!socketData.err) toast.success(socketData.msg);
        else toast.error(socketData.msg);
      }
    }
    // Game Info
    if (socketData.en === "MINI_LOTTERY_GAME_INFO") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false));
      dispatch(SET_GAME_TIMER(socketData.data.timer));
      dispatch(SET_LAST_WIN_CARD(socketData.data.last_win_cards));
      dispatch(SET_CURRENT_GAME_TIME(socketData.data.draw_time));
      dispatch(SET_NEXT_GAME_TIME(socketData.data.next_deal_time));
      dispatch(SET_LAST_SALE_AMOUNT(socketData.data.last_sale_amount));
      dispatch(SET_TR_CODE(socketData.data.game_id));
      dispatch(SET_LAST_TICKET_ID(socketData.data.ticket_id));
      dispatch(SET_USER_WALLET(socketData.data.total_wallet));
      dispatch(SET_ANNOUCEMENTS(socketData.data.annoucements));
    }


    if (socketData.en === 'MINI_LOTTERY_GAME_REMAING_TIMER') {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_GAME_TIMER(socketData.data.timer))
    }

    // MINI_LOTTERY_LOCK_BET
    if (socketData.en === "MINI_LOTTERY_LOCK_BET") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(true))
      navigate('/2d/auto-result')
    }
    // MINI_LOTTERY_START_SPIN
    if (socketData.en === "MINI_LOTTERY_START_SPIN") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_GAME_TIMER(socketData.data.timer))
    }

    // MINI_LOTTERY_WINNER_DECLARE
    if (socketData.en === 'MINI_LOTTERY_WINNER_DECLARE') {
      dispatch(SET_LAST_WIN_CARD(socketData.data.last_win_cards))
      // dispatch(SET_PREVIEWS_GAME_TIME(socketData.data.draw_time))
      dispatch(SET_AUTO_RESULT_DATA(socketData.data.last_win_cards))
      dispatch(SET_NEXT_GAME_TIME(socketData.data.next_deal_time))
    }

    //"MINI_LOTTERY_INIT_GAME"
    if (socketData.en === "MINI_LOTTERY_INIT_GAME") {
    }
    // if (socketData.en === "MINI_LOTTERY_WIN") {
    //   dispatch(SET_MAIN_LOADER(false))
    //   dispatch(SET_WIN_LOSE_RECORD(socketData.data))
    //   navigate('/2d/win-lose-result')
    // }
    // if (socketData.en === "MINI_LOTTERY_LOSE") {
    //   dispatch(SET_MAIN_LOADER(false))
    //   dispatch(SET_WIN_LOSE_RECORD(socketData.data))
    //   navigate('/2d/win-lose-result')
    // }

    if (socketData.en === "MINI_LOTTERY_GAME_TIMER_START") {
      dispatch(SET_GAME_TIMER(socketData.data.timer))
      dispatch(SET_CURRENT_GAME_TIME(socketData.data.draw_time))
      dispatch(SET_NEXT_GAME_TIME(socketData.data.next_deal_time))
      dispatch(SET_MAIN_LOADER(false))
    }

    // COMPLAINT
    if (socketData.en === 'COMPLAIN') {
      dispatch(SET_MAIN_LOADER(false))
      navigate('/2d')
      dispatch(SHOW_MAIN_SUCCESS_MODAL(socketData.data.msg))
    }

    // time sloat
    if (socketData.en === 'MINI_LOTTERY_ADVANCE_DRAW_TIME_SLOT') {
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_TIME_SLOT(socketData.data.time_slot))
    }

    // place bat
    // if (socketData.en === 'TWO_CHANCE_PLACE_BET') {
    //   if (socketData.err) {
    //     dispatch(SET_MAIN_LOADER(false))
    //     dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
    //     return
    //   }
    //   dispatch(SET_1D_LAST_SALE_AMOUNT(socketData.data.total_bet_amount))
    //   dispatch(SET_1D_LAST_TICKET_ID(socketData.data.ticket_id))
    //   PrintData(socketData.data, dispatch)
    //   dispatch(RESET_1D_SLICE_STATE());
    //   dispatch(SET_1D_ADVANCE_DRAW_SELECT_TIME([]))
    //   dispatch(setAdvanceTimeSlotCount(0))
    // }

    if (socketData.en === 'PICK_THREE_REPORT') {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(setLotteryReport3d(socketData.data.game_lists));
    }

    // LOTTERY_REPORT
    if (socketData.en === "MINI_LOTTERY_REPORT") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_LOTTERY_REPORT(socketData.data.game_lists));
    }

    // UPDATED_WALLET
    if (socketData.en === "UPDATED_WALLET") {
      dispatch(SET_USER_WALLET(socketData.data.chips))
      dispatch(SET_1D_USER_WALLET(socketData.data.chips))
      dispatch(setWalletAmount3d(socketData.data.chips));
      dispatch(SET_TITLI_USER_WALLET(socketData.data.chips));
      dispatch(SET_PANA_WALLET(socketData.data.chips));
    }

    if (socketData.en === "MINI_LOTTERY_TICKET_CLAIM") {
      dispatch(SET_MAIN_LOADER(false));
      dispatch(clearWinLoseRecord3d());
      dispatch(clearTitliWinLoseRecord());
      dispatch(SET_WIN_LOSE_RECORD(socketData))
      navigate('/2d/win-lose-result')
      dispatch(SET_CLAIM_TICKET_RECORD(socketData))
    }

    if (socketData.en === "LUCKY_SORAT_CLAIM_TICKET") {
      dispatch(SET_MAIN_LOADER(false))
      dispatch(clearWinLoseRecord());
      dispatch(clearWinLoseRecord3d());
      dispatch(SET_TITLI_WIN_LOSE_RECORD(socketData))
      navigate('/titli/win-lose-result')
      dispatch(SET_TITLI_CLAIM_TICKET_RECORD(socketData))
    }

    if (socketData.en === "TWO_CHANCE_TICKET_CLAIM") {
      dispatch(SET_MAIN_LOADER(false))
      dispatch(clear1DWinLoseRecord());
      dispatch(SET_1D_WIN_LOSE_RECORD(socketData))
      navigate('/1d/win-lose-result')
      dispatch(SET_1D_CLAIM_TICKET_RECORD(socketData))
    }

    // LOTTERY_GET_BET_LISTS

    if (socketData.en === "MINI_LOTTERY_GET_BET_LISTS") {
      if (socketData.err) {
        navigate('/2d')
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_REPRNT_LIST(socketData.data.list))
      navigate(`/2d/reprint/list`)

    }

    if (socketData.en === "TWO_CHANCE_GET_BET_LISTS") {
      if (socketData.err) {
        navigate('/1d')
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_1D_REPRNT_LIST(socketData.data.list))
      navigate(`/1d/reprint1d/list`)

    }

    if (socketData.en === "LUCKY_SORAT_GET_BET_LISTS") {
      if (socketData.err) {
        navigate('/titli')
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_TITLI_REPRNT_LIST(socketData.data.list))
      navigate(`/titli/reprint/list`)

    }

    // MINI_LOTTERY_CANCEL_TICKET
    if (socketData.en === "MINI_LOTTERY_CANCEL_TICKET") {
      if (socketData.err) {
        navigate('/2d')
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      navigate('/2d')
      dispatch(SHOW_MAIN_SUCCESS_MODAL(socketData.data.msg))
    }

    if (socketData.en === "TWO_CHANCE_CANCEL_TICKET") {
      if (socketData.err) {
        navigate('/1d')
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      navigate('/1d')
      dispatch(SHOW_MAIN_SUCCESS_MODAL(socketData.data.msg))
    }

    if (socketData.en === "LUCKY_SORAT_CANCEL_BET") {
      if (socketData.err) {
        navigate('/titli')
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      navigate('/titli')
      dispatch(SHOW_MAIN_SUCCESS_MODAL(socketData.data.msg))
    }

    // Reprint tickets
    if (socketData.en === "MINI_LOTTERY_PRINT_TICKETS") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      // dispatch(SET_MAIN_LOADER(false))
      RePrintData(socketData.data.ticket_info, dispatch)
    }

    if (socketData.en === "TWO_CHANCE_PRINT_TICKETS") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      // dispatch(SET_MAIN_LOADER(false))
      RePrintData1d(socketData.data.ticket_info, dispatch)
    }


    if (socketData.en === "LUCKY_SORAT_PRINT_TICKETS") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      // dispatch(SET_MAIN_LOADER(false))
      RePrintDataTitli(socketData.data.ticket_info, dispatch)
    }


    // result Data  
    if (socketData.en === 'MINI_LOTTERY_RESULTS_HISTORY') {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_RESULT_DATA(socketData.data.result))
    }

    if (socketData.en === 'MINI_LOTTERY_FILTER_RESULTS_HISTORY') {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_RESULT_DATA(socketData.data.result))
    }

    // RESET_PASSWORD
    if (socketData.en === "RESET_PASSWORD") {
      if (socketData.err) {
        dispatch(SET_MAIN_LOADER(false))
        dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg))
        return
      }
      dispatch(SET_MAIN_LOADER(false))
      navigate('/2d')
      dispatch(SHOW_MAIN_SUCCESS_MODAL(socketData.data.msg))
    }

    // WALLET_DEATILS
    if (socketData.en === "WALLET_DEATILS") {
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SET_USER_WALLET(socketData.data.chips + socketData.data.game_winning))
    }

    // OSR
    if (socketData.en === "OSR") {
      localStorage.removeItem('creditionls')
      socket.disconnect()
    }

    if (socketData.en === "USER_BLOCK") {
      dispatch(SET_MAIN_LOADER(false))
      dispatch(SHOW_MAIN_ERROR_MODAL('You are block'))
      localStorage.removeItem('creditionls')
      socket.disconnect()
    }

    if (socketData.en === "MINI_LOTTERY_ANNOUCEMENT")
      dispatch(SET_ANNOUCEMENTS(socketData.data.annoucements))

  }, [dispatch, navigate, socket]);

  // Handle token check and navigation
  useEffect(() => {
    if (localStorage.getItem('gametoken')) {
      navigate("/3d");
      // token code
    } else if (!userDetail) {
      navigate("/login");
    }
  }, [userDetail, navigate]);


  // Handle socket disconnection
  const handleDisconnect = useCallback(() => {
    if (!window.location.pathname.includes('/login') && localStorage.getItem('creditionls')) {
      socket?.connect();
      dispatch(SET_MAIN_LOADER(true));
      const creditionls = localStorage.getItem('creditionls');
      const data = {
        "en": "AppLunchDetails",
        "data": JSON.parse(creditionls)
      };
      socket?.emit("req", data);
    } else {
      socket?.connect();
      setUserDetail(null);
      navigate('/login');
    }
  }, [dispatch, navigate, socket]);

  // Set up socket event listeners
  useEffect(() => {
    if (!socket) return;

    const onDisconnect = () => handleDisconnect();
    const onResponse = (data) => handleSocketResponse(data);

    socket.on('disconnect', onDisconnect);
    socket.on('res', onResponse);

    return () => {
      socket.off('disconnect', onDisconnect);
      socket.off('res', onResponse);
    };
  }, [socket, handleDisconnect, handleSocketResponse]);

  useEffect(() => {
    if (!socket) return;

    const sendHeartbeat = () => {
      socket.emit('hb', {});
    };

    // When socket connects, send immediately
    socket.on('connect', () => {
      sendHeartbeat();

      // Start interval after connection
      const interval = setInterval(sendHeartbeat, 10000);

      // Cleanup on unmount or reconnect
      socket.on('disconnect', () => clearInterval(interval));

      return () => clearInterval(interval);
    });

    // Cleanup all listeners on unmount
    return () => {
      socket.off('connect');
      socket.off('disconnect');
    };
  }, [socket]);


  // Handle connection errors
  useEffect(() => {
    if (connectionError) {
      // You might want to show an error message or attempt to reconnect
      console.error('Socket connection error:', connectionError);
    }
  }, [connectionError]);

  const state = {
    userDetail,
    setUserDetail,
    reconnectSocket: reconnect
  };

  return (
    <AuthContext.Provider value={state}>
      {children}
    </AuthContext.Provider>
  );
}

const AuthState = () => useContext(AuthContext);

export { AuthState };
export default AuthProvider;